module.exports = {
  searchOoo: "Buscar...",
  selectAll: "Seleccionar todo",
  page: "Página",
  of: "de",
  loadingOoo: "Cargando...",
  clearFilter: "Limpiar",
};



// WEBPACK FOOTER //
// ./src/components/localeTextAgGrid.js